module.exports = __webpack_public_path__ + "img/box-lucky.01ec5963.png";